'use client';

import NotFoundPage from '@/components/NotFoundPage';

const BuyerNotFoundPage = (): JSX.Element => {
  /* 
    The LegacyPageWrapper prevents us from using notFound(); The following code in LegacyPageWrapper
    seems to be returned while the user is already signed in which breaks the Router:
      if (!isUserCheckComplete || !currentUser) {
        return <></>;
      }
    For now, the workaround is to use NotFoundPage instead of notFound(); in this file.
  */
  return <NotFoundPage redirectPath="/" />;
};

export default BuyerNotFoundPage;
